import(/* webpackMode: "eager", webpackExports: ["LobbyPage"] */ "/app/src/modules/lobby/index.tsx");
